import React, { ReactElement, WeakValidationMap } from 'react';
import PropTypes from 'prop-types';
import { forgeClassHelper } from '../utils/classes';

const classes = forgeClassHelper('list');

export interface ListProps extends React.HTMLAttributes<HTMLUListElement> {
  /** Child ListItem components to render */
  children?: React.ReactNode;

  /** Adds a class to the root element of the component */
  className?: string;

  /** When true, adds a border line between items, but not at the top or bottom */
  dividers?: boolean;

  /** When true, adds default padding that can be removed when the parent already provides a gutter */
  padded?: boolean;
}

/**
 * List
 *
 * A component to render a list of items.
 */
const List = ({ dividers = false, padded = true, className, ...rootProps }: ListProps): ReactElement => {
  const classNames = classes({
    extra: className,
    modifiers: { dividers, padded },
  });

  return (
    <ul {...rootProps} {...classNames}>
      {rootProps.children}
    </ul>
  );
};

export const listPropTypes: WeakValidationMap<ListProps & { '...rest': unknown }> = {
  /** Adds a class to the root element of the component */
  className: PropTypes.string,
  /** Adds a border line between items, but not at the top or bottom */
  dividers: PropTypes.bool,
  /** Adds default padding that can be removed when the parent already provides a gutter */
  padded: PropTypes.bool,
  /** ListItem content */
  children: PropTypes.node,
  /** Passthrough props to the `<ul>` element */
  '...rest': PropTypes.any,
};

List.propTypes = listPropTypes;

export default List;
